import React from 'react';
import s from './Product.module.css';

const Product = (props) => {
    return (
        <div className={s.holder}>
            <div className={s.top}>
                <span className={s.name}>{props.name}</span>
                <span className={s.price}>{props.price}</span>
            </div>
            <div className={s.bottom}>
                <div className={s.info}>
                    <div><span>{props.info1}</span></div>
                    <div><span>{props.info2}</span></div>
                    <div><span>{props.info3}</span></div>
                    <div><span>{props.info4}</span></div>
                    <div><span>{props.info5}</span></div>
                    <div><span>{props.info6}</span></div>
                </div>
                <div className={s.weight}>{props.weight}</div>
            </div>
        </div>
    )
}

export default Product;